import { FETCH_INV_POSTS_FAILURE, FETCH_INV_POSTS_REQUEST, FETCH_INV_POSTS_SUCCESS } from '../actions/postActions';

const initData = {
  data: [],
  isLoading: false,
  error: null,
};

const invDataReducer = (state = initData, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_INV_POSTS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_INV_POSTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: payload,
      };
    case FETCH_INV_POSTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    default:
      return state;
  }
};

export default invDataReducer;
